import { TextField, TextFieldProps } from '@mui/material';

export const TextInput = ({ ...props }: Omit<TextFieldProps, 'type'>) => {
  return <TextField {...props} type="text" />;
};
